export default __webpack_public_path__ + "static/bg_map-ad4abe8fb9d840d4b2ee8f0d4ffdfdbf.jpg";